/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable no-empty-pattern */
import LinearProgress from '@mui/material/LinearProgress';

interface Props {
    label?: string;
}

const PageLoader = ({ label }: Props) => {
    return (
        <LinearProgress
            data-testid={`loader-${label}`}
            sx={{
                height: 2,
                width: '100%',
                left: 0,
                right: 0,
                top: 0,
                position: 'absolute',
                backgroundColor: '#0559ad',
            }}
        />
    );
};

export default PageLoader;
